import React from 'react';

import { Box } from '@material-ui/core';

const Pagina = props => (
	<Box component="main" flex={1} overflow="scroll" p={2} {...props} />
);

export default Pagina;
